module.exports = __webpack_public_path__ + "img/056757e.jpg";